<ng-container *transloco="let t; read: 'builder'">
    <div class="inset-0 flex flex-row min-w-0 overflow-hidden bg-gray-50 w-full h-full" *ngIf="formDefinition">
        <div
            cdkDropList
            [cdkDropListData]="fieldTypes"
            cdkDropListSortingDisabled
            [cdkDropListConnectedTo]="[componentsList]"
            (cdkDropListExited)="onSourceListExited($event)"
            (cdkDropListEntered)="onSourceListEntered($event)"
            class="w-96 bg-card border-r"
        >
            <toolbar [fieldTypes]="fieldTypes"></toolbar>
        </div>

        <div class="w-full flex flex-col items-center">
            <div class="flex flex-row items-center p-4 bg-gray-100 w-full border-b place-content-between z-50">
                <div class="flex-1"></div>
                <span class="flex-1 text-center font-semibold">{{ t("Preview") }}</span>
                <div class="flex-1 flex flex-row place-content-end">
                    <button
                        mat-stroked-button
                        (click)="openFieldExpressionSettings()"
                        [disabled]="!(this.formDefinition.fields.length > 1)"
                    >
                        <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
                        <span class="ml-2">{{ t("Field Expression Settings") }}</span>
                    </button>
                </div>
            </div>

            <div
                class="w-160 h-full my-6 p-8 space-y-6 flex flex-col rounded items-center"
                [ngClass]="isDragging ? 'bg-black bg-opacity-12 ' : 'bg-white'"
                cdkScrollable
                fuseScrollbar
            >
                <form [formGroup]="form" class="w-128 flex flex-col space-y-4">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Título</mat-label>
                        <input
                            [formControlName]="'title'"
                            [placeholder]="'Título do formulário'"
                            autocomplete="off"
                            matInput
                            cdkFocusInitial
                            required
                        />
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Descrição</mat-label>
                        <input
                            [formControlName]="'description'"
                            [placeholder]="'Descrição do formulário'"
                            autocomplete="off"
                            matInput
                            [required]="descriptionRequired"
                        />
                    </mat-form-field>
                </form>

                <div
                    #componentsList="cdkDropList"
                    cdkDropList
                    [cdkDropListData]="formDefinition.fields"
                    class="bg-white"
                    (cdkDropListDropped)="drop($event)"
                >
                    <div
                        class="w-128 min-h-48 flex flex-col space-y-4 border rounded-sm border-dashed border-gray-300 items-center place-content-center pt-4"
                        [ngClass]="isDragging ? 'border-solid border-gray-400' : ''"
                    >
                        <span class="text-lg font-medium text-hint">
                            Escolha os tipos de campos no menu à esquerda
                        </span>
                        <span class="text-lg font-medium text-hint"> Arraste e solte os campos aqui </span>
                        <div class="flex flex-col space-y-3 items-center place-content-center p-2">
                            <control-preview
                                *ngFor="let field of formDefinition.fields"
                                [field]="field"
                                (onEdit)="edit($event)"
                                (onDelete)="delete($event)"
                                (onDuplicate)="duplicate($event)"
                            ></control-preview>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-row p-4 space-x-6 bg-gray-100 w-full border-t place-content-center z-50">
                <button mat-button (click)="cancel()">Cancelar</button>
                <button mat-stroked-button [disabled]="!form.valid || !formDefinition.valid" (click)="render()">
                    <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
                    <span class="ml-2">Visualizar</span>
                </button>
                <button
                    mat-flat-button
                    color="primary"
                    [disabled]="!form.valid || !formDefinition.valid"
                    (click)="save()"
                >
                    Salvar formulário
                </button>
            </div>
        </div>
    </div>
</ng-container>
